import { SourceType } from 'module/api/filter/types';
import { useTranslate } from 'module/hooks/use-translation';
import { FilterableField } from 'module/types/filter-field/field/filterable-field';
import { GroupedOptions } from 'module/types/filter-field/field/grouped-field';
import { FilterGroupType } from 'module/types/filter-field/grouped-filter/group';
import { sortBy, startCase } from 'lodash';
import {
  filterTypeForSourceType,
  iconForGroupedFilter,
} from './entity-for-filter-type';

export const getFilterGroupType = (
  value: SourceType,
  defaultType?: FilterGroupType,
): FilterGroupType => {
  const filterType = filterTypeForSourceType[value];

  return filterType ?? defaultType ?? FilterGroupType.Task;
};

export const groupedFieldsTransformerFunction = (
  fieldOption: GroupedOptions<FilterableField>,
): GroupedOptions<FilterableField> => ({
  ...fieldOption,
  label: fieldOption.label || startCase(fieldOption.id),
  options: sortBy(
    fieldOption.options.map((_option) => ({
      label: _option.fieldLabel,
      value: _option.fieldId as any,
      ..._option,
    })),
    ({ fieldLabel, fieldName }) => fieldLabel ?? startCase(fieldName),
  ),
});
type FilterableFieldAsOption = Omit<FilterableField, 'value'> & {
  value: number;
  label: string;
};
export const asFilterableFieldOption = (
  field: FilterableField,
): FilterableFieldAsOption => ({
  ...field,
  label: field.fieldLabel ?? startCase(field.fieldName),
  value: field.fieldId,
});
export const asGroupedFilterableFieldOption = (
  fields: GroupedOptions<FilterableField>[],
): GroupedOptions<FilterableFieldAsOption>[] =>
  fields.map((field) => ({
    ...field,
    options: field?.options?.map(asFilterableFieldOption) ?? [],
  }));

type FieldsByGroupType = Partial<
  Record<
    FilterGroupType,
    {
      fields: FilterableField[];
    }
  >
>;

export const asGroupedFieldOptionsForFilter = (
  fieldsByGroupType: FieldsByGroupType,
  translate: ReturnType<typeof useTranslate>,
): GroupedOptions<FilterableField>[] => {
  return Object.entries(fieldsByGroupType).map(([groupType, { fields }]) => ({
    id: groupType,
    label: translate(`grouped_filter.${groupType.toLowerCase()}` as any),
    options: sortBy(
      fields,
      ({ fieldLabel, fieldName }) => fieldLabel ?? fieldName,
    ),
    icon: iconForGroupedFilter[groupType],
  }));
};
